import { getCountryOptions } from './countriesUtils';

export function getCountryOption(country: string | null) {
    const countryOptions = getCountryOptions();
    if (country) {
        return {
            label: countryOptions.find((item) => item.value === country)?.label,
            value: country,
        };
    }
}
